import { COUNTRY_FILTER_DISABLED, COUNTRY_FILTER_ENABLED } from '../actions/country_filter'

export function countryFilter(state = { countryFilter: null }, action) {
  switch (action.type) {
    case COUNTRY_FILTER_ENABLED:
      return { ...state, countryFilter: action.countryFilter }
    case COUNTRY_FILTER_DISABLED:
      return { ...state, countryFilter: action.countryFilter }
    default:
      return state
  }
}
